<template v-if="data">
  <div class="mb-m">
    <h3 
      class="mb-xs fz-small pl-s l-border blue"
      v-text="data.type"
    />
    <div class="insu-prod-details-list list">
      <template v-if="data.items.length > 0">
        <div 
          v-for="(item, i) in data.items"
          :key="i"
          class="list-item flex flex-ss"
        >
          <div class="mb-xs item-heading">
            <h4 
              class="mb-xxs title detail-title fz-tiny"
              v-text="item.title"
            />
            <div 
              class="amount detail-amount fz-tiny tips-primary"
              v-text="item.amount"
            />
          </div>
          <p 
            class="item-content detail-desc fz-tiny"
            v-text="item.desc"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: null
      }
    }
  };
</script>